import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Button, Dialog, Text } from "@sundae/ui-toolkit";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import cx from "classnames";
import { capitalize } from "lodash";
import { useEffect } from "react";
import { useBrandConfig } from "../../../hooks";
import { useEnvConfig } from "../../../hooks/useEnvConfig";
import { Actions, useAppContext } from "../../../stores";
import { getEnvNameFromNetwork } from "../../../utils/wallet";
export const WrongNetworkDialog = () => {
    const { t } = useI18N("wallet");
    const env = useEnvConfig();
    const brand = useBrandConfig();
    const { state: { networkOpen }, dispatch, } = useAppContext();
    const { disconnect, network, activeWallet } = useWalletObserver();
    useEffect(() => {
        if (activeWallet &&
            network !== undefined &&
            !networkOpen &&
            env.envName !== getEnvNameFromNetwork(network)) {
            Actions.setNetworkOpen(true, dispatch);
        }
    }, [network, networkOpen, env.envName, activeWallet]);
    return (_jsx(Dialog, { closeDialog: () => Actions.setNetworkOpen(false, dispatch), open: networkOpen, children: _jsxs("div", { className: "flex max-w-[540px] flex-col items-center justify-center gap-4 p-8", children: [_jsx(Text, { tag: "h2", className: "text-4xl font-bold", children: t("error.wrong_network.title") }), _jsx(Text, { tag: "p", className: "text-center", children: t("error.wrong_network.desc", {
                        wrong_network: capitalize(getEnvNameFromNetwork(network)),
                        right_network: capitalize(env.envName),
                    }) }), _jsx(Button, { className: cx(brand?.classes.buttons.all, brand?.classes.buttons.secondary), variant: "secondary", onClick: async () => {
                        disconnect();
                        Actions.setNetworkOpen(false, dispatch);
                    }, children: t("actions.disconnect") })] }) }));
};
export default WrongNetworkDialog;
//# sourceMappingURL=WrongNetworkDialog.js.map